import axios from 'axios'

export default {
  getFiles(date, type, search) {
    const query = {
      params: {
        filters: []
      }
    }
    if (search) {
      query.params.filters = [
        {
          param: 'name',
          needle: [search],
          isStrict: false
        }
      ]
    } else {
      query.params.path = `${date.year}-${date.month}`
    }

    if (type.length > 0) {
      query.params.filters.push({
        param: 'type',
        needle: type,
        isStrict: false
      })
    } else {
      query.params.filters.push({
        param: 'type',
        needle: ['img', 'video', 'pdf'],
        isStrict: false
      })
    }
    return axios.get('/api/files/', query)
  },
  uploadFiles(files) {
    const fd = new FormData()
    for (let i = 0; i < files.length; i += 1) {
      fd.append('file', files[i], files[i].name)
    }
    return axios.post('/api/files/upload', fd)
  },
  getWorkspace(type) {
    const query = {
      params: {}
    }
    if (type.length > 0) {
      query.params.type = type
    } else {
      query.params.type = ['img', 'video', 'pdf']
    }
    return axios.get('/api/files/workspace', query)
  }
}
